/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForDynatrace extends models.ServiceAccountNativeDetailsBaseForSaasOtherServices {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForDynatrace");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForDynatrace.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForDynatrace>): ServiceAccountNativeDetailsForDynatrace {
        let obj = Object.assign(new ServiceAccountNativeDetailsForDynatrace(), model);
        ServiceAccountNativeDetailsForDynatrace.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForDynatrace>): ServiceAccountNativeDetailsForDynatrace {
        if (!model) return null;
        return ServiceAccountNativeDetailsForDynatrace.newInstance(<ServiceAccountNativeDetailsForDynatrace> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForDynatrace) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForDynatrace.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForDynatrace): boolean {
        if (models.ServiceAccountNativeDetailsBaseForSaasOtherServices.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForDynatrace.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
